"use client";
var L = 1, H = 0.9, J = 0.8, Y = 0.17, p = 0.1, u = 0.999, $ = 0.9999, k = 0.99, B = /[\\\/_+.#"@\[\(\{&]/, K = /[\\\/_+.#"@\[\(\{&]/g, W = /[\s-]/, D = /[\s-]/g;
function G(c, C, h, P, f, A, O) {
  if (A === C.length)
    return f === c.length ? L : k;
  var T = `${f},${A}`;
  if (O[T] !== void 0)
    return O[T];
  for (var U = P.charAt(A), E = h.indexOf(U, f), S = 0, _, N, M, R; E >= 0; )
    _ = G(
      c,
      C,
      h,
      P,
      E + 1,
      A + 1,
      O
    ), _ > S && (E === f ? _ *= L : B.test(c.charAt(E - 1)) ? (_ *= J, M = c.slice(f, E - 1).match(K), M && f > 0 && (_ *= Math.pow(u, M.length))) : W.test(c.charAt(E - 1)) ? (_ *= H, R = c.slice(f, E - 1).match(D), R && f > 0 && (_ *= Math.pow(u, R.length))) : (_ *= Y, f > 0 && (_ *= Math.pow(u, E - f))), c.charAt(E) !== C.charAt(A) && (_ *= $)), (_ < p && h.charAt(E - 1) === P.charAt(A + 1) || P.charAt(A + 1) === P.charAt(A) && // allow duplicate letters. Ref #7428
    h.charAt(E - 1) !== P.charAt(A)) && (N = G(
      c,
      C,
      h,
      P,
      E + 1,
      A + 2,
      O
    ), N * p > _ && (_ = N * p)), _ > S && (S = _), E = h.indexOf(U, E + 1);
  return O[T] = S, S;
}
function X(c) {
  return c.toLowerCase().replace(D, " ");
}
function j(c, C, h) {
  return c = h && h.length > 0 ? `${c + " " + h.join(" ")}` : c, G(
    c,
    C,
    X(c),
    X(C),
    0,
    0,
    {}
  );
}
export {
  j as commandScore
};
